import { Link, useMatches } from 'react-router-dom';

import { Tooltip } from '@components';

export const SidebarNavLink = ({ children, to, exact, tooltip }) => {
  // are any router matches the same path as the Link
  //
  // needs to check against all matches since we have a
  // wildcard (*) match in routes for 404 catching
  const matches = useMatches();
  const anyMatch =
    matches.length && matches.some((match) => match.pathname == to);

  let link = (
    <Link to={to} className="sb-flex sb-sidebar-item">
      {children}
    </Link>
  );
  if (tooltip) {
    // ability to pass a tooltip to the nav item
    link = (
      <Tooltip tooltip={tooltip} placement="right">
        {link}
      </Tooltip>
    );
  }

  return <li className={anyMatch ? 'active' : null}>{link}</li>;
};
